import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Loader } from 'rsuite'

export default function ShortCode() {
    const { id } = useParams()
    const [status, setStatus] = useState('empty')

    useEffect(() => {
        if (!id) return
        axios
            .get(`${process.env.REACT_APP_API_URL}/api/v1/shorten/${id}`)
            .then((res) => {
                setStatus(res?.data?.status)
                if (res?.data?.status === 200) {
                    setTimeout(() => {
                        window.location.href = res?.data?.data
                    }, 2000)
                }
            })
            .catch((res) => {
                setStatus(res.status)
            })
        return () => {}
    }, [id])

    return (
        <div className="flex flex-col items-center justify-center w-full bg-white gap-8">
            <img src="/images/logo.svg" alt="icon" style={{ height: 90 }} />
            {status === 501 ? (
                <div className="flex items-center justify-center text-red-500 text-lg">
                    Houve um erro ao tentar te redirecionar :( ({status})
                </div>
            ) : status === 404 ? (
                <div className="flex flex-col items-center justify-center text-lg">
                    <span>URL não encontrada</span>
                </div>
            ) : status === 200 ? (
                <div className="flex flex-col items-center justify-center text-lg">
                    <span>Redirecionando para o site da transportadora...</span>
                </div>
            ) : (
                <Loader size="lg" content="Aguarde..." vertical />
            )}
        </div>
    )
}
